module.exports = __webpack_public_path__ + "img/swp1.e57d7327.png";